import { 
  SupportAgent, 
  SupportContact, 
  SupportMessage, 
  SupportTicket, 
  SupportThread,
  SupportNote 
} from '../types/support-ticket';
import { v4 as uuidv4 } from 'uuid';

// Mock Support Agents
export const mockAgents: SupportAgent[] = [
  {
    id: 'agent-1',
    name: 'John Smith',
    email: 'john.smith@orgmanage.com',
    role: 'agent',
    department: 'Technical Support',
    available: true,
    created_at: new Date(2023, 1, 15).toISOString()
  },
  {
    id: 'agent-2',
    name: 'Maria Rodriguez',
    email: 'maria.rodriguez@orgmanage.com',
    role: 'supervisor',
    department: 'Customer Success',
    available: true,
    created_at: new Date(2023, 2, 10).toISOString()
  },
  {
    id: 'agent-3',
    name: 'Alex Wong',
    email: 'alex.wong@orgmanage.com',
    role: 'admin',
    department: 'IT Operations',
    available: false,
    created_at: new Date(2023, 0, 5).toISOString()
  }
];

// Mock Support Contacts
export const mockContacts: SupportContact[] = [
  {
    id: 'contact-1',
    name: 'Jennifer Lawrence',
    email: 'jennifer@acmecorp.com',
    phone: '+1234567890',
    customer_id: 'customer-1',
    created_at: new Date(2023, 3, 12).toISOString()
  },
  {
    id: 'contact-2',
    name: 'Mike Johnson',
    email: 'mike@globaltech.com',
    phone: '+1987654321',
    customer_id: 'customer-2',
    created_at: new Date(2023, 4, 20).toISOString()
  },
  {
    id: 'contact-3',
    name: 'Sarah Wilson',
    email: 'sarah@innovate.io',
    phone: '+1567891234',
    customer_id: 'customer-3',
    created_at: new Date(2023, 5, 8).toISOString()
  },
  {
    id: 'contact-4',
    name: 'David Chen',
    email: 'david@nextstep.com',
    customer_id: 'customer-4',
    created_at: new Date(2023, 6, 15).toISOString()
  }
];

// Mock Support Threads
export const mockThreads: SupportThread[] = [
  {
    id: 'thread-1',
    contact_id: 'contact-1',
    channel: 'email',
    subject: 'Unable to access my account',
    last_message_at: new Date(2023, 10, 10, 14, 35).toISOString(),
    is_active: true,
    created_at: new Date(2023, 10, 10, 14, 0).toISOString()
  },
  {
    id: 'thread-2',
    contact_id: 'contact-2',
    channel: 'whatsapp',
    subject: 'Billing inquiry',
    last_message_at: new Date(2023, 10, 11, 9, 45).toISOString(),
    is_active: true,
    created_at: new Date(2023, 10, 11, 9, 30).toISOString()
  },
  {
    id: 'thread-3',
    contact_id: 'contact-3',
    channel: 'live_chat',
    subject: 'Feature request',
    last_message_at: new Date(2023, 10, 9, 16, 25).toISOString(),
    is_active: false,
    created_at: new Date(2023, 10, 9, 16, 0).toISOString()
  },
  {
    id: 'thread-4',
    contact_id: 'contact-4',
    channel: 'email',
    subject: 'Integration problem',
    last_message_at: new Date(2023, 10, 8, 10, 15).toISOString(),
    is_active: false,
    created_at: new Date(2023, 10, 8, 10, 0).toISOString()
  }
];

// Mock Support Messages
export const mockMessages: SupportMessage[] = [
  // Thread 1 messages
  {
    id: 'msg-1-1',
    thread_id: 'thread-1',
    sender_type: 'contact',
    sender_id: 'contact-1',
    content: 'Hi, I\'m having trouble logging into my account. It says my password is incorrect but I\'m sure it\'s right.',
    created_at: new Date(2023, 10, 10, 14, 0).toISOString()
  },
  {
    id: 'msg-1-2',
    thread_id: 'thread-1',
    sender_type: 'agent',
    sender_id: 'agent-1',
            content: 'Hello Jennifer, I\'m sorry to hear you\'re having trouble. Please contact your system administrator for assistance.',
    created_at: new Date(2023, 10, 10, 14, 10).toISOString()
  },
  {
    id: 'msg-1-3',
    thread_id: 'thread-1',
    sender_type: 'contact',
    sender_id: 'contact-1',
    content: 'Yes, I tried that but I\'m not receiving the reset email.',
    created_at: new Date(2023, 10, 10, 14, 20).toISOString()
  },
  {
    id: 'msg-1-4',
    thread_id: 'thread-1',
    sender_type: 'agent',
    sender_id: 'agent-1',
    content: 'Let me check your account. Could you please confirm the email address you\'re using to log in?',
    created_at: new Date(2023, 10, 10, 14, 35).toISOString()
  },
  
  // Thread 2 messages
  {
    id: 'msg-2-1',
    thread_id: 'thread-2',
    sender_type: 'contact',
    sender_id: 'contact-2',
    content: 'I think there\'s an error on my last invoice. The amount seems higher than usual.',
    created_at: new Date(2023, 10, 11, 9, 30).toISOString()
  },
  {
    id: 'msg-2-2',
    thread_id: 'thread-2',
    sender_type: 'agent',
    sender_id: 'agent-2',
    content: 'Good morning Mike, I\'d be happy to look into this for you. Could you please provide your account number or the invoice number?',
    created_at: new Date(2023, 10, 11, 9, 45).toISOString()
  },
  
  // Thread 3 messages
  {
    id: 'msg-3-1',
    thread_id: 'thread-3',
    sender_type: 'contact',
    sender_id: 'contact-3',
    content: 'I\'d like to suggest a new feature for your platform. Would it be possible to add calendar integration?',
    created_at: new Date(2023, 10, 9, 16, 0).toISOString()
  },
  {
    id: 'msg-3-2',
    thread_id: 'thread-3',
    sender_type: 'agent',
    sender_id: 'agent-3',
    content: 'Thank you for your suggestion, Sarah! We actually have calendar integration on our roadmap for next quarter. Would you be interested in joining our beta testing group?',
    created_at: new Date(2023, 10, 9, 16, 15).toISOString()
  },
  {
    id: 'msg-3-3',
    thread_id: 'thread-3',
    sender_type: 'contact',
    sender_id: 'contact-3',
    content: 'Yes, I would love to join the beta testing! Please let me know when it\'s available.',
    created_at: new Date(2023, 10, 9, 16, 25).toISOString()
  },
  
  // Thread 4 messages
  {
    id: 'msg-4-1',
    thread_id: 'thread-4',
    sender_type: 'contact',
    sender_id: 'contact-4',
    content: 'I\'m trying to integrate your API with our system but I\'m getting authentication errors.',
    created_at: new Date(2023, 10, 8, 10, 0).toISOString()
  },
  {
    id: 'msg-4-2',
    thread_id: 'thread-4',
    sender_type: 'agent',
    sender_id: 'agent-1',
    content: 'Hi David, I\'ll help you with that. Could you share the error message you\'re receiving and which authentication method you\'re using?',
    created_at: new Date(2023, 10, 8, 10, 15).toISOString()
  }
];

// Mock Support Tickets
export const mockTickets: SupportTicket[] = [
  {
    id: 'ticket-1',
    thread_id: 'thread-1',
    contact_id: 'contact-1',
    agent_id: 'agent-1',
    subject: 'Account access issue',
            description: 'Customer unable to log in and needs assistance with authentication',
    status: 'open',
    priority: 'high',
    category: 'incident',
    created_at: new Date(2023, 10, 10, 14, 40).toISOString(),
    updated_at: new Date(2023, 10, 10, 15, 0).toISOString(),
    due_date: new Date(2023, 10, 11, 14, 40).toISOString()
  },
  {
    id: 'ticket-2',
    thread_id: 'thread-4',
    contact_id: 'contact-4',
    agent_id: 'agent-1',
    subject: 'API Integration Problem',
    description: 'Customer experiencing authentication errors when integrating with our API',
    status: 'solved',
    priority: 'medium',
    category: 'service_request',
    created_at: new Date(2023, 10, 8, 10, 30).toISOString(),
    updated_at: new Date(2023, 10, 9, 11, 0).toISOString(),
    resolution: 'Provided correct authentication token and updated documentation',
    resolution_date: new Date(2023, 10, 9, 11, 0).toISOString()
  },
  {
    id: 'ticket-3',
    contact_id: 'contact-2',
    agent_id: 'agent-2',
    subject: 'Change request for additional user licenses',
    description: 'Customer needs to add 5 more user licenses to their enterprise plan',
    status: 'pending',
    priority: 'low',
    category: 'change_request',
    created_at: new Date(2023, 10, 7, 9, 0).toISOString(),
    updated_at: new Date(2023, 10, 7, 14, 30).toISOString(),
    due_date: new Date(2023, 10, 14, 9, 0).toISOString()
  },
  {
    id: 'ticket-4',
    contact_id: 'contact-3',
    agent_id: 'agent-3',
    subject: 'Recurring system slowdown',
    description: 'Customer reporting system slowdown during peak hours, affecting multiple users',
    status: 'on_hold',
    priority: 'urgent',
    category: 'problem',
    created_at: new Date(2023, 10, 5, 16, 0).toISOString(),
    updated_at: new Date(2023, 10, 10, 11, 0).toISOString(),
    due_date: new Date(2023, 10, 12, 16, 0).toISOString(),
    sla_breach: true
  }
];

// Mock Support Notes
export const mockNotes: SupportNote[] = [
  {
    id: 'note-1',
    ticket_id: 'ticket-1',
    author_id: 'agent-1',
    content: 'Checked user account in admin panel. Email is correct but account is locked due to multiple failed login attempts.',
    is_private: true,
    created_at: new Date(2023, 10, 10, 14, 55).toISOString()
  },
  {
    id: 'note-2',
    ticket_id: 'ticket-2',
    author_id: 'agent-1',
    content: 'Customer was using deprecated authentication method. Guided them to updated documentation.',
    is_private: true,
    created_at: new Date(2023, 10, 8, 11, 30).toISOString()
  },
  {
    id: 'note-3',
    ticket_id: 'ticket-3',
    author_id: 'agent-2',
    content: 'Waiting for approval from billing department to add the additional licenses.',
    is_private: true,
    created_at: new Date(2023, 10, 7, 14, 30).toISOString()
  },
  {
    id: 'note-4',
    ticket_id: 'ticket-4',
    author_id: 'agent-3',
    content: 'Escalated to development team. Appears to be related to recent deploy.',
    is_private: false,
    created_at: new Date(2023, 10, 6, 9, 0).toISOString()
  }
]; 